module.exports = __webpack_public_path__ + "img/kcd.520b7832.jpg";